import React from 'react';
import { Drawer, Form, Button, Space, DatePicker, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;

const FilterDrawer = ({
  visible,
  onClose,
  onFinish,
  fields = [],
  loading = false,
  initialValues = {},
}) => {
  const [form] = Form.useForm();

  // Reset form and filters
  const handleReset = () => {
    form.resetFields();
    onFinish({}); // Pass empty object to reset filters
  };

  // Reset form when drawer opens/closes
  React.useEffect(() => {
    if (visible) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [visible, initialValues, form]);

  const renderField = (field) => {
    switch (field.type) {
      case 'date-range':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
          >
            <RangePicker
              showTime={field.showTime}
              format={field.format || 'YYYY-MM-DD HH:mm:ss'}
              style={{ width: '100%' }}
              disabledDate={field.disabledDate}
            />
          </Form.Item>
        );

      case 'select':
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
          >
            <Select
              mode={field.mode}
              options={field.options}
              placeholder={field.placeholder}
              allowClear
              style={{ width: '100%' }}
            />
          </Form.Item>
        );

      case 'text':
      default:
        return (
          <Form.Item
            key={field.name}
            name={field.name}
            label={field.label}
          >
            <Input
              placeholder={field.placeholder}
              prefix={field.prefix || <SearchOutlined />}
            />
          </Form.Item>
        );
    }
  };

  return (
    <Drawer
      title="Filter"
      placement="right"
      onClose={onClose}
      open={visible}
      width={400}
      footer={
        <Space>
          <Button onClick={handleReset}>Reset</Button>
          <Button
            type="primary"
            onClick={() => form.submit()}
            loading={loading}
          >
            Apply Filters
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
        preserve={false}
      >
        {fields.map(renderField)}
      </Form>
    </Drawer>
  );
};

export default FilterDrawer;
